import React from 'react'
import { NavLink } from 'react-router-dom'

const A = ({ external, children, ...props }) => {
  return external ? (
    <a {...props} target='_blank'>
      {children}
    </a>
  ) : (
    <NavLink {...props}>{children}</NavLink>
  )
}

const Link = ({
  external,
  group,
  className,
  noDecoration,
  href,
  style,
  events,
  children
}) => (
  <A
    external={external}
    className={`ui gp-text gp-link link-${group} ${className} ${
      noDecoration ? 'no-decoration' : ''
    }`}
    to={href}
    href={typeof href === 'object' ? href.pathname : href}
    style={style}
    {...(events || {})}
  >
    {children}
  </A>
)

Link.defaultProps = {
  group: 'a',
  className: '',
  style: {}
}

export default Link
